
import { divWithStyle } from '@tableau/data-catalog-shared';
import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Sparkline } from '../widgets/sparkline/Sparkline';
import { dataDetailsContentWidth } from './ViewerPaneStyles';

const SparklineCaption = divWithStyle('sparkline-caption', {
  fontSize: TabStyles.Typography.Sizing.Small,
  color: TabStyles.Typography.Color.Secondary,
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.DefaultSpace,
  textAlign: 'right'
});
const sparklineWidth = dataDetailsContentWidth;
const sparklineHeight = 66;

/**
 * A wrapper around the Sparkline component that adds a caption below.
 */
export class SparklineWithCaption extends React.Component<SparklineWithCaptionProps> {

  public render(): JSX.Element {
    return (
      <>
        <Sparkline
          width={sparklineWidth}
          height={sparklineHeight}
          dataPoints={this.props.dataPoints}
          title={this.props.caption}
        />

        { /*
          Currently, the sparkline element has static width and does not resize with the container if its width changes
          (e.g. if a scrollbar appears on the container, taking up space on the right edge). Hence, we declare an
          explicit width on the caption element so that it always appears right-aligned with the sparkline element.
        */ }
        <SparklineCaption style={{ width: sparklineWidth }}>
          {this.props.caption}
        </SparklineCaption>
      </>
    );
  }
}

export interface SparklineWithCaptionProps {
  readonly caption: string;
  readonly dataPoints: ReadonlyArray<number>;
}

